import { __assign } from "tslib";
import { createAutoAssignApi } from './index';
import { createHttpTestKit } from '../../http/test-kit';
import { createChatAutoAssignApiTestkit } from './chat/testkit';
export var createAutoAssignSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAutoAssignApi('', fakeHttp);
    var testKit = {
        chat: createChatAutoAssignApiTestkit(),
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map